import { Button, Text } from "../../components";
import React from "react";

export default function EventActionSection() {
  return (
    <>
      {/* event action section */}
      <div className="mb-1 mt-32">
        <div className="flex border-t border-solid border-gray-200 bg-white-a700 px-3.5 py-4">
          <div className="mx-auto flex w-full max-w-[1162px] items-center justify-center">
            <div className="flex flex-1 flex-col items-start gap-1.5">
              <Text size="text2xl" as="p" className="text-[16px] font-normal !text-gray-900_02">
                Price
              </Text>
              <Text size="text2xl" as="p" className="text-[16px] font-normal !text-orange-900">
                200 EGP
              </Text>
            </div>
            <Button className="flex h-[44px] min-w-[188px] flex-row items-center justify-center self-end rounded-[10px] bg-orange-900 px-[34px] text-center font-inter text-[16px] font-medium text-white-a700 sm:px-5">
              Buy Tickets
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
